import {
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Typography,
  withStyles,
} from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import CloseIcon from '@material-ui/icons/Close';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import styles from './GenericModalCadastro.scss';
import languageValues from 'utils/LanguageUtils';
import TooltipCaller from 'components/TooltipManager/TooltipCaller';
import { HelpButton } from 'components/HelpButton';
import { getElementID, getMergedClassNames } from 'utils/HTMLUtils';

const rootClassName = styles.rootClassName;

const DialogTitle = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    color: theme.palette.grey[500],
    margin: '-12px -12px 0 0',
  },
}))((props) => {
  const { children, classes, className, onClose, closeText, closeButtonId } =
    props;
  return (
    <MuiDialogTitle
      disableTypography
      className={getMergedClassNames([classes.root, className])}
    >
      <Typography variant='h6'>{children}</Typography>
      {typeof onClose === 'function' ? (
        <TooltipCaller text={closeText}>
          <IconButton
            id={closeButtonId}
            aria-label='Close'
            className={classes.closeButton}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        </TooltipCaller>
      ) : (
        ''
      )}
    </MuiDialogTitle>
  );
});

export default class GenericModalCadastro extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      modalId: props.id || null,
      contentRef: React.createRef(),
      needScroll: false,
      scrollIsStart: false,
      scrollIsEnd: false,
    };

    this.handleOpen = this.handleOpen.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);
  }

  handleOpen(open) {
    this.setState({
      ...this.state,
      open: open,
      innerWidth: window.innerWidth,
    });
  }

  updateDimensions() {
    let newState = {
      innerWidth: window.innerWidth,
    };
    if (this.state.contentRef.current) {
      const contentContainerComputedStyle = window.getComputedStyle(
        this.state.contentRef.current
      );
      const contentComputedStyle = window.getComputedStyle(
        this.state.contentRef.current.childNodes[0]
      );
      const containerHeight =
        parseInt(contentContainerComputedStyle.height) -
        parseInt(contentContainerComputedStyle.paddingTop) -
        parseInt(contentContainerComputedStyle.paddingBottom);
      newState.needScroll =
        parseInt(contentComputedStyle.height) > containerHeight ? true : false;
      newState.scrollIsStart =
        parseInt(this.state.contentRef.current.scrollTop) === 0 ? true : false;
      newState.scrollIsEnd =
        parseInt(this.state.contentRef.current.offsetHeight) +
          parseInt(this.state.contentRef.current.scrollTop) ===
        parseInt(this.state.contentRef.current.scrollHeight)
          ? true
          : false;
    }
    this.setState(newState);
  }

  onEntered = () => {
    this.updateDimensions();
  };

  UNSAFE_componentWillMount() {
    this.updateDimensions();
  }
  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
    this.updateDimensions();
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  getDialogProps() {
    return {
      open: true,
      fullWidth: true,
      maxWidth: 'md',
      fullScreen: this.state.innerWidth < 534,
      'aria-labelledby': 'max-width-dialog-title',
      ...this.props.DialogProps,
      // Deprecated
      disableBackdropClick: undefined,
      disableEscapeKeyDown: true,
      className: getMergedClassNames([
        rootClassName,
        typeof this.props.onSubmit === 'function'
          ? rootClassName + '-with-form'
          : '',
        this.props.DialogProps && this.props.DialogProps.className
          ? this.props.DialogProps.className
          : '',
        this.state.needScroll ? rootClassName + '-need-scroll' : '',
        this.state.scrollIsStart ? rootClassName + '-scroll-is-start' : '',
        this.state.scrollIsEnd ? rootClassName + '-scroll-is-end' : '',
      ]),
      onEntered: this.oneEntered,
      onClose: (_, reason) => {
        if (reason !== 'backdropClick') {
          if (typeof this.props.onClose === 'function') {
            this.props.onClose();
          }
          this.handleOpen(false);
        }
      },
    };
  }

  getHint() {
    if (typeof this.props.titleHint === 'string') {
      return (
        <HelpButton
          text={this.props.titleHint}
          className={rootClassName + '-header-hint-button'}
        />
      );
    }
    return null;
  }

  getForm = (children) => {
    if (typeof this.props.onSubmit === 'function') {
      return (
        <form
          {...{
            onSubmit:
              typeof this.props.onSubmit === 'function'
                ? this.props.onSubmit
                : null,
          }}
        >
          {children}
        </form>
      );
    }
    return children;
  };

  render() {
    let dialogTitleClassNames = [rootClassName + '-title'];
    if (this.props.DialogTitleProps && this.props.DialogTitleProps.className) {
      dialogTitleClassNames.push(this.props.DialogTitleProps.className);
    }
    const allDialogTitleProps = {
      ...this.props.DialogTitleProps,
      closeButtonId: this.state.modalId
        ? getElementID(this.state.modalId, 'close')
        : null,
      className: dialogTitleClassNames.join(' '),
    };
    const dialogContentProps = {
      ...this.props.DialogContentProps,
      className: getMergedClassNames([
        rootClassName + '-content',
        this.props.footerContent ? rootClassName + '-with-actions' : '',
        this.props.DialogContentProps && this.props.DialogContentProps.className
          ? this.props.DialogContentProps.className
          : '',
      ]),
      onScroll: this.updateDimensions,
      ref: this.state.contentRef,
    };
    const dialogActionsProps = {
      className: getMergedClassNames([rootClassName + '-actions']),
    };
    return (
      <Dialog {...this.getDialogProps()}>
        {this.getForm(
          <>
            <DialogTitle
              {...allDialogTitleProps}
              onClose={this.props.onClose}
              closeText={languageValues.actions.closeModal}
            >
              {this.props.title}
              {this.getHint()}
            </DialogTitle>
            <DialogContent {...dialogContentProps}>
              {this.props.children}
            </DialogContent>
            {this.props.footerContent ? (
              <DialogActions {...dialogActionsProps}>
                {this.props.footerContent}
              </DialogActions>
            ) : null}
          </>
        )}
      </Dialog>
    );
  }
}

GenericModalCadastro.propTypes = {
  id: PropTypes.string,
  open: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  titleHint: PropTypes.string,
  onClose: PropTypes.func,
  DialogProps: PropTypes.object,
  DialogTitleProps: PropTypes.object,
  DialogContentProps: PropTypes.object,
  footerContent: PropTypes.object,
  onSubmit: PropTypes.func,
  children: PropTypes.any,
  modalKey: PropTypes.string,
};
